import { apiRequest } from "../util/apiUtils";

export const orderList = async (params) => {
  try {
    const res = await apiRequest("get", `order/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderDetails = async (params) => {
  try {
    const res = await apiRequest("get", `order/detail/${params?.id}`, {
      queries: { ...(params?.type && { type: params?.type }) },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `order/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `order/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `order/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `order/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderPlace = async (payload) => {
  try {
    const res = await apiRequest("post", `order/place`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderCancel = async (payload) => {
  try {
    const res = await apiRequest("patch", `order/cancel`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const orderItemEdit = async (payload) => {
  try {
    const res = await apiRequest("put", `order/item/edit`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionList = async (payload) => {
  try {
    const res = await apiRequest("get", `order/item-list`, {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionDelete = async (payload) => {
  try {
    const res = await apiRequest("put", `order/item-list`, {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionOrdering = async (payload) => {
  try {
    const res = await apiRequest("put", `order/item-list`, {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("put", `order/item-list`, {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const dynamicOrderList = async (params) => {
  try {
    const res = await apiRequest("get", `form/response/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pendingBookingComplete = async (payload) => {
  try {
    const res = await apiRequest("patch", `order/booking/complete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
